import React from "react";
import PropTypes from "prop-types";
import { getAgentInfo, getEntityToShow } from "../../shared/util";

class ShAgents extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    const { entity, listing } = this.props;
    if (listing.isSir) {
      this.ref.current.listing = listing;
      this.ref.current.agents = [getAgentInfo(entity)];
    }
    // const referrer = getEntityToShow(entity);
    // const hideCourtesy =
    //   !listing.agents ||
    //   0 === listing.agents.length ||
    //   listing.agents.some((a) => a.email === referrer.emailAddress);
    // if (!hideCourtesy) {
    //   this.ref.current.sirCourtesyOf = listing.agents.slice(0, 3);
    //   this.ref.current.brand = referrer.brand;
    // }
  }

  render() {
    return <sh-agents ref={this.ref}></sh-agents>;
  }
}

ShAgents.propTypes = {
  entity: PropTypes.object.isRequired,
  listing: PropTypes.object.isRequired,
};

export default ShAgents;



// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/sh-agents.js